export default {
  GET_REPORT_ALL_WEB_SITE_PUBLISHER: "GET_REPORT_ALL_WEB_SITE_PUBLISHER",
  GET_REPORT_ALL_WEB_SITE_PUBLISHER_SUCCESS:
    "GET_REPORT_ALL_WEB_SITE_PUBLISHER_SUCCESS",
  GET_REPORT_ALL_WEB_SITE_PUBLISHER_FAILED:
    "GET_REPORT_ALL_WEB_SITE_PUBLISHER_FAILED",

  GET_REPORT_WEB_SITE_PUBLISHER: "GET_REPORT_WEB_SITE_PUBLISHER",
  GET_REPORT_WEB_SITE_PUBLISHER_SUCCESS:
    "GET_REPORT_WEB_SITE_PUBLISHER_SUCCESS",
  GET_REPORT_WEB_SITE_PUBLISHER_FAILED: "GET_REPORT_WEB_SITE_PUBLISHER_FAILED",

  SET_DATE_REPORT_FILTER: "SET_DATE_REPORT_FILTER",

  SET_SITE_PUBLISHER_ID: "SET_SITE_PUBLISHER_ID",

  GET_REPORT_ALL_WEB_SITE_PUBLISHER_DATA_CHART:
    "GET_REPORT_ALL_WEB_SITE_PUBLISHER_DATA_CHART",
  GET_REPORT_ALL_WEB_SITE_PUBLISHER_DATA_CHART_SUCCESS:
    "GET_REPORT_ALL_WEB_SITE_PUBLISHER_DATA_CHART_SUCCESS",
  GET_REPORT_ALL_WEB_SITE_PUBLISHER_DATA_CHART_FAILED:
    "GET_REPORT_ALL_WEB_SITE_PUBLISHER_DATA_CHART_FAILED",

  GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART:
    "GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART",
  GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART_SUCCESS:
    "GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART_SUCCESS",
  GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART_FAILED:
    "GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART_FAILED",

  EMPTY_SITE_PUBLISHER_DATA_SEPARATION: "EMPTY_SITE_PUBLISHER_DATA_SEPARATION",

  GET_SITE_PUBLISHER_SEPARATION_DATA_CHART:
    "GET_SITE_PUBLISHER_SEPARATION_DATA_CHART",
  GET_SITE_PUBLISHER_SEPARATION_DATA_CHART_SUCCESS:
    "GET_SITE_PUBLISHER_SEPARATION_DATA_CHART_SUCCESS",
  GET_SITE_PUBLISHER_SEPARATION_DATA_CHART_FAILED:
    "GET_SITE_PUBLISHER_SEPARATION_DATA_CHART_FAILED",

  GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART:
    "GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART",
  GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART_SUCCESS:
    "GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART_SUCCESS",
  GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART_FAILED:
    "GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART_FAILED",

  SET_TYPE_SEPARATION_DATA_CHART: "SET_TYPE_SEPARATION_DATA_CHART",
};
